import React from 'react';
import Picture from './Picture';
import ConditionBadges from './ConditionBadges';
import { RefreshIcon, PlusIcon, TrashIcon } from '@heroicons/react/outline';
import i18next from 'i18next';
import '../styles/dm.css';

const CompanyMemberCard = ({ member, onOpen, onDelete }) => (
  <div className={`dmCompanyCard${member.isNpc ? ' npc' : ''}`} onClick={() => onOpen(member.uid)}>
    {member.isNpc && <span className='dmNpcBadge'>{i18next.t('npc.badge')}</span>}
    {member.isNpc && onDelete && (
      <button
        className='dmNpcDelete'
        title={i18next.t('npc.delete')}
        onClick={(e) => {
          e.stopPropagation();
          if (window.confirm(i18next.t('npc.deleteConfirm'))) onDelete(member.uid);
        }}
      >
        <TrashIcon />
      </button>
    )}
    <Picture character={member} />
    <div className='dmCompanyCardInfo'>
      <b>{member.name}</b>
      <span>{member.currentHp} / {member.maxHp} HP</span>
    </div>
    {(member.conditions || []).length > 0 && (
      <ConditionBadges conditions={member.conditions} />
    )}
  </div>
);

const DmCompany = ({ company, onOpenSheet, reloadCompany, onCreateNpc, onDeleteNpc }) => (
  <div className='containerCompanyList'>
    <div className='dmCompanyToolbar'>
      <RefreshIcon className="iconReload" onClick={reloadCompany} />
      {onCreateNpc && (
        <button className='dmCreateNpcBtn' onClick={onCreateNpc}>
          <PlusIcon /> {i18next.t('npc.create')}
        </button>
      )}
    </div>
    <div className='dmCompanyGrid'>
      {company.map((member, i) => (
        <CompanyMemberCard
          key={member.uid || i}
          member={member}
          onOpen={onOpenSheet}
          onDelete={onDeleteNpc}
        />
      ))}
    </div>
  </div>
);

export default DmCompany;
